import React from 'react';
import {
  Typography,
  Switch,
  Stack,
  Box
} from '@mui/material';

const toggleLabelSx = {
  fontSize: '12px',
  color: 'rgb(90,90,90)',
  textAlign: 'center'
};

const toggleTitleSx = {
  textAlign: 'center'
};

const toggleContainerSx = {
  borderTop: '1px solid black',
  padding: '8px 25px'
};

const defaultProps = {
  value: false,
  label: '',
  ariaLabel: '',
  toggleSideLabels: ['','']
};

export default function ToggleSelector({
  handleChangeSelection,
  id=null,
  value=defaultProps.value,
  label=defaultProps.label,
  ariaLabel=defaultProps.ariaLabel,
  toggleSideLabels=defaultProps.toggleSideLabels,
}) {
  return (
    <Box sx={toggleContainerSx} id={id}>
      <Box sx={toggleTitleSx}>{label}</Box>
      <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        {toggleSideLabels[0] ? <Typography sx={toggleLabelSx}>{toggleSideLabels[0]}</Typography> : ''}
        <Switch
          checked={value}
          onChange={(e) => handleChangeSelection(e.target.checked)}
          inputProps={{ 'aria-label': ariaLabel ? ariaLabel : label }}
        />
        {toggleSideLabels[1] ? <Typography sx={toggleLabelSx}>{toggleSideLabels[1]}</Typography> : ''}
      </Stack>
    </Box>
  );
}

export { defaultProps };